import { render, staticRenderFns } from "./teachers-full.vue?vue&type=template&id=90748a82&"
import script from "./teachers-full.vue?vue&type=script&lang=js&"
export * from "./teachers-full.vue?vue&type=script&lang=js&"
import style0 from "./teachers-full.vue?vue&type=style&index=0&id=90748a82&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports